import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("notFound.title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          {t("notFound.body")}{" "}
          <Link
            to="/"
            className="text-primary underline-offset-4 hover:underline"
          >
            {t("notFound.backHome")}
          </Link>
          .
        </p>
      </CardContent>
    </Card>
  );
}
